import { Link } from 'react-router-dom';
import { useNavigate, useLocation  } from "react-router-dom";
import { useEffect, useState } from 'react';

import { Radio, Button, Input, Space, message, Carousel, Divider } from 'antd';
import callAPI from '../../comps/fetch/main'
import { InstagramOutlined } from '@ant-design/icons';
import {style2} from '../signup/main.css'
import {style1} from './main.css'
import logo from '../../images/logo.png'

function Signup() {

    
    const navigate = useNavigate();
    const [messageApi, contextHolder] = message.useMessage();

    const location = useLocation();
    const isSignup = location.pathname === '/signup' ? true : false;
  
    const urlParams = new URLSearchParams(window.location.search);

    // Get the value of the 'ncid' parameter
    const ncid = urlParams.get('ncid');

    if (ncid) {
         localStorage.setItem("ncid", ncid);
    }
    let options = [
        {
          label: 'Create New Account',
          value: 'ca',
        },
        {
          label: 'Login to your Account ',
          value: 'lg',
        }, ]
    
    const [submitting, setSubmitting] = useState(false)
    

    const[selectedOption, setSelectedOption] = useState('ca')

          useEffect(() => {
            const params = new URLSearchParams(window.location.search);
            const ref = params.get('ref');
            if (ref) {
              // alert(ref)
              localStorage.setItem('refCode', ref);
              
              
            } else {
              // fallback to what's in localStorage already
              const storedRef = localStorage.getItem('refCode');
              
            }
          }, []);

    function LoginComp() {

        const[email, setEmail] = useState('')
        const[password, setPassword] = useState('')
        const [errors, setErrors] = useState({})
        const [submitting, setSubmitting] = useState(false)
        const [response, setResponse] = useState({})
        const [payload,setPayload] = useState({})

        useEffect(() => {
          
            if( response?.code == 200) {

                localStorage.setItem("token" , response.data.token)
                localStorage.removeItem("refCode")
                localStorage.setItem("userData" , JSON.stringify(response.data.data))
                localStorage.setItem("agency",true)
                
                if(response.data?.agency == true){

                  localStorage.setItem("agency-token" , response.data.token)
                  
                  navigate("/")
                  return

                }

                response.data?.default_page?.id != undefined ? navigate('/') : navigate('/ig-connect?show_ig_connect=true')
                
            }
            if( response?.code !=undefined && response.code !=200) {
              
                messageApi.open({
                    type: 'error',
                    content: response.message,
                  });
                
                setResponse({})
                  return
            }

        } , [response])


     

        useEffect(() => {
            if(payload?.email){
                setSubmitting(true)
                let apiURL = `user-login`
                messageApi.open({
                    key:"login loading",
                    type: 'loading',
                    content: 'Logging you in...',
                  });
                callAPI({url:apiURL, method: "PUT",body:payload, loadingState:setSubmitting ,  dataState:setResponse}  )
                
            }
            else{
                return
            }
        } , [payload])
        
        

        const handleLogin = () => {
            const errors = {}
            if (!email) {
                errors.email = 'Email is required';
              } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
                errors.email = 'Invalid email address';
              }
            
              if (!password) {
                errors.password = 'Password is required';
              }
              if (Object.keys(errors).length > 0) {
                setErrors(errors)

      
              } else {
                  setErrors({})
                    setPayload({
                        email , 
                        password
                    })
                
              }
        }

    // let scopes = "instagram_basic,instagram_content_publish,instagram_manage_comments,instagram_manage_insights,pages_show_list,pages_read_engagement"
    let scopes = "business_basic,business_content_publish,business_manage_comments,business_manage_messages"
    // let appId = "433149449449290"
    let appId = "996086435858506"
    let redirectURL = "https://app.instantdm.com/fb-rdr"
    let url = `https://www.instagram.com/oauth/authorize?client_id=${appId}&redirect_uri=${redirectURL}&response_type=code&scope=${scopes}`


        return (
            <>

                    <h3>Welcome back 👋</h3>
                    <Button onClick={() => {
                      localStorage.setItem("signup-flow" , true)
                      window.location.href = url

                    }} color="pink" variant="solid" size='large' icon={<InstagramOutlined />}>Continue With Instagram</Button>
                    <Divider>or Continue with Email</Divider>
                    <Input placeholder='Enter your email' value={email} onChange={(e) => setEmail(e.target.value)}  size="large" disabled={submitting} />
                        { errors.email &&  <p className='error'>{errors.email}</p> }
                    <Input.Password value={password} onChange={(e) => {setPassword(e.target.value)}}  placeholder='Enter your password' size="large" disabled={submitting} />
                        { errors.password &&  <p className='error'>{errors.password}</p> }
                    <Button type="primary" block style={{backgroundColor:'#8b54f3', marginTop:'20px'}}  size="large" onKeyDown={handleLogin}  onClick={handleLogin} loading={submitting}>
                        Login
                    </Button>
                    <a style={{marginTop:'4px'}} className='tns-link' target='_blank' href='/reset-password'>Forgot password?</a>

            </>
        )
    }

    function SignupComp() {

        
        const [fullname, setFullName] = useState('')
        const [email, setEmail] = useState('')
        const [igID, setIgIG] = useState('')
        const [password, setPassword] = useState('')
        const [rpassword, setRPassword] = useState('')
        const [refCode, setRefCode] = useState('')
        const [errors, setErrors] = useState({})
        const [response, setResponse] = useState({})
        const [accountType, setAccountType] = useState(false)
        const [payload,setPayload] = useState({})
        const [submitting, setSubmitting] = useState(false)
        const [disablerefInput, setDisableRefInput] = useState(false)

        useEffect(() => {
            messageApi.destroy()
            if( response?.code == 200) {

              handleSuccess(payload)
              
                localStorage.setItem("token" , response.data.token)
                localStorage.removeItem("refCode")
                localStorage.setItem("userData" , JSON.stringify(response.data.data))
                // Store token
                navigate('/ig-connect?show_ig_connect=true')                
            }
            if( response?.code && response.code !=200) {
                messageApi.open({
                    type: 'error',
                    content: response.message,
                  });
            }

        } , [response])


        const handleSuccess = async (data) => {
          try {
            await sendWelcomeEmail(data);
          } catch (error) {
            console.error(error);
          }
        };

        const sendWelcomeEmail = async (data) => {
          await fetch(`https://send-welcome-email.sanjayhotaction.workers.dev/?email=${data?.email}&name=${data?.name}`);
        };

        useEffect(() => {
            if(payload?.email){
                setSubmitting(true)
                messageApi.open({
                    key:"signup loading",
                    type: 'loading',
                    content: 'Creating Account...',
                  });
                
                  let user_tz = Intl.DateTimeFormat().resolvedOptions().timeZone
                  let apiURL = `user-signup`
                  callAPI({url:apiURL, method: "POST" , body:{...payload,user_tz}, loadingState:setSubmitting ,  dataState:setResponse}  )
                  
                  // const BOT_TOKEN = "7109212238:AAEsaFubA66rs0Ib6rgn5K2amKO9rnOkUv0";
                  // const CHAT_ID = '776956029';
                  // const url = `https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`;
                  // let tele_message = `[TRYING TO SIGNUP] - user ${payload?.email} - ${payload?.igID} - tz ${user_tz}`
                  
                  
                  // let data = {
                  //     chat_id: CHAT_ID,
                  //     text: tele_message
                  // };


                  const now = new Date();

                  // Format the date as yyyy-mm-dd
                  const year = now.getFullYear();
                  const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
                  const day = String(now.getDate()).padStart(2, '0');

                  // Format the time as hh:mm (24-hour format)
                  const hours = String(now.getHours()).padStart(2, '0');
                  const minutes = String(now.getMinutes()).padStart(2, '0');

                  // Combine into the desired format: "yyyy-mm-dd hh:mm"
                  const formattedDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
                  
                  if(ncid){
                    fetch("https://app.nocodb.com/api/v2/tables/mm4ydtsjnqh6gid/records", {
                      method: 'PATCH',
                      headers: {
                          'Content-Type': 'application/json',
                          "xc-token":"feFZVvr1uKXprz_xkJkmVqYwIp4UL_3fsm19yBkq"
                      },
                      body: JSON.stringify([{ Id:ncid, "email_id":payload?.email ,"status":"signup","signup-at":formattedDateTime}])
                  })
                  .then(response => response.json())
                  .then(data => {
                      // console.log('Message sent successfully:', data);
                  })
                  .catch(error => {
                      // console.error('Error sending message:', error);
                  });
                  }
          
                  // fetch(url, {
                  //     method: 'POST',
                  //     headers: {
                  //         'Content-Type': 'application/json'
                  //     },
                  //     body: JSON.stringify(data)
                  // })
                  // .then(response => response.json())
                  // .then(data => {
                  //     // console.log('Message sent successfully:', data);
                  // })
                  // .catch(error => {
                  //     // console.error('Error sending message:', error);
                  // });

            }
            else{
                return
            }
        } , [payload])
    
        const handleSignup = () => {
            const errors = {};
          
            if (!fullname) {
              errors.fullname = 'Name is required';
            } else if (fullname.length < 3) {
              errors.fullname = 'Name must be at least 3 characters long';
            }
          
            if (!email) {
              errors.email = 'Email is required';
            } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)) {
              errors.email = 'Invalid email address';
            }
          
            if (!password) {
              errors.password = 'Password is required';
            } else if (password.length < 8) {
              errors.password = 'Password must be at least 8 characters long';
            }
          
            if (!rpassword) {
              errors.rpassword = 'Repeat password is required';
            } else if (rpassword !== password) {
              errors.rpassword = 'Passwords do not match';
            }
          
            if (Object.keys(errors).length > 0) {
              // display errors to the user
              setErrors(errors)
              // console.log(errors);
    
              // you can also use a library like react-toastify to display toast notifications
            } else {
                setErrors({})
              
                setPayload({
                    fullname,
                    email, 
                    password,
                    refCode,
                    igID,
                    agency : accountType
                })
            }
          };
          
          useEffect(() => {
            const params = new URLSearchParams(window.location.search);
            const ref = params.get('ref');
            console.log("REFCODE-==-=-=", ref)
            if (ref) {
              // alert(ref)
              localStorage.setItem('refCode', ref);
              setDisableRefInput(true);
              setRefCode(ref);
            } else {
              // fallback to what's in localStorage already
              const storedRef = localStorage.getItem('refCode');
              if (storedRef) setRefCode(storedRef);
            }
          }, []);

        return ( <>
        <Input placeholder='Enter your full name' value={fullname} onChange={(e) => {setFullName(e.target.value)}}   size="large" disabled={submitting}/>
       { errors.fullname &&  <p className='error'>{errors.fullname}</p> }
        <Input placeholder='Enter your email' value={email} onChange={(e) => {setEmail(e.target.value)}}   size="large" disabled={submitting} />
        { errors.email &&  <p className='error'>{errors.email}</p> }
        <Input.Password placeholder='Enter your password' value={password} onChange={(e) => {setPassword(e.target.value)}}   size="large" disabled={submitting}/>
        { errors.password &&  <p className='error'>{errors.password}</p> }
        <Input.Password placeholder='Re-Enter your password' value={rpassword} onChange={(e) => {setRPassword(e.target.value)}}   size="large" disabled={submitting}/>
        { errors.rpassword &&  <p className='error'>{errors.rpassword}</p> }
        {/* <Input placeholder='@insta_username' value={igID} onChange={(e) => {setIgIG(e.target.value)}}   size="large" disabled={submitting}/> */}
        <Input disabled={disablerefInput || submitting} placeholder='Referral Code if any (Optional)' value={refCode} onChange={(e) => {setRefCode(e.target.value)}}   size="large"/>
        <div style={{
          display: "flex",
          flexDirection: "row",
          alignContent: "space-evenly",
          alignItems: "center",
          justifyContent: "space-between",
          justifyItems: "center",
          width: "100%"
        }}>
        <p style={{opacity:'.40'}}>Account Type</p>
        <Radio.Group
          value={accountType}
          onChange={(e) => setAccountType(e.target.value)}
          options={
            [
              {
                label: 'Creator',
                value: false,
              },
              {
                label: 'Agency',
                value: true,
              }
            ]
          }
          defaultValue="creator"
          optionType="button"
          buttonStyle="solid"
        />
        </div>
        <Button type="primary" block style={{backgroundColor:'#8b54f3' , marginTop:'20px'}} onKeyDown={handleSignup} size="large" onClick={handleSignup} loading={submitting}>
            Create Account
        </Button>
        <p className='tns'>By proceeding , you agree to <a className='tns-link' target='_blank' href='https://instantdm.com/privacy.html'>our terms and conditions.</a> </p>
        </>)

    }

    function SignupTwo(){


    // let scopes = "instagram_basic,instagram_content_publish,instagram_manage_comments,instagram_manage_insights,pages_show_list,pages_read_engagement"
    let scopes = "business_basic,business_content_publish,business_manage_comments,business_manage_messages"
    // let appId = "433149449449290"
    let appId = "996086435858506"
    let redirectURL = "https://app.instantdm.com/fb-rdr"
    let url = `https://www.instagram.com/oauth/authorize?client_id=${appId}&redirect_uri=${redirectURL}&response_type=code&scope=${scopes}`



      return ( <>
       
        <Button onClick={() => {
          localStorage.setItem("signup-flow" , true)
          window.location.href = url

        }} color="pink" variant="solid" size='large' icon={<InstagramOutlined />}>Continue With Instagram</Button>
        {/* <Divider>or Continue with Email</Divider>
        <SignupComp/> */}
        </>)

    }

    return(
        
        <div className='account-setup signup'>
          {contextHolder}
          
            
            <div className='core-div'>

            <div className='flex-space-between'>
              <div className='header-content'>
              <img className='desktop'src="/logo192.png"alt="Logo" style={{ height: '62px', width: '62px' }} />
              <img className='mobile' src="/logo192.png"alt="Logo" style={{ height: '62px', width: '62px' }} />
                  <h1> { isSignup ? "Create your InstantDM account" : "Login to your InstantDM account" }</h1>
                  <p> { isSignup ? "Meta verified and approved instagram DM automation tool" : "Please fill your details to continue" }</p>
              </div>            
            </div>


            <div className='singup-box'>

            { isSignup ? <SignupTwo/> : <LoginComp /> }

            

            { isSignup ? <a style={{marginTop:'10px'}} href='/login' className='help'>Already Registered? Login</a> : <a style={{marginTop:'10px'}} href='/signup' className='help'>Create new account</a> }
            <a style={{marginTop:'10px'}} target="_blank" href='https://instagram.com/instant.dm' className='help'>Need Help? Contact us</a>

            </div>
            
            </div>
            
            
        </div>
    )

}

export default Signup;